// Apollo Client 3's ApolloError keeps .message clean, but its name is "ApolloError", so
// String(err) / `${err}` / {{ err }} render "ApolloError: <message>". Apollo Client 4 uses
// "CombinedGraphQLErrors" for GraphQL errors and "ServerError" for non-2xx responses, which
// render the same way. Apollo Client 2 put "GraphQL error: " inside .message itself. Strip
// all of them so the UI shows just the message.
const ERROR_PREFIX = /^(ApolloError|CombinedGraphQLErrors|ServerError|GraphQL error):\s*/;

export function errorMessage(err: unknown): string {
  const message = typeof (err as { message?: unknown } | null)?.message === 'string'
    ? (err as { message: string }).message
    : String(err);
  return message.replace(ERROR_PREFIX, '');
}
